"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.map_area = void 0;

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var map_area = function map_area(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'map_area-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    // eslint-disable-next-line max-len
    d: 'M3 2.75C2.86193 2.75 2.75 2.86193 2.75 3V17C2.75 17.1381 2.86193 17.25 3 17.25H17C17.1381 17.25 17.25 17.1381 17.25 17V3C17.25 2.86193 17.1381 2.75 17 2.75H3ZM1.25 3C1.25 2.0335 2.0335 1.25 3 1.25H17C17.9665 1.25 18.75 2.0335 18.75 3V17C18.75 17.9665 17.9665 18.75 17 18.75H3C2.0335 18.75 1.25 17.9665 1.25 17V3ZM8.364 4.6025C8.55637 4.29471 8.94154 4.16884 9.27854 4.30364L14.2785 6.30364C14.5633 6.41754 14.75 6.69332 14.75 7V12C14.75 12.1989 14.671 12.3897 14.5303 12.5303L11.5303 15.5303C11.3897 15.671 11.1989 15.75 11 15.75H6.5C6.08579 15.75 5.75 15.4142 5.75 15V9C5.75 8.85944 5.7895 8.7217 5.864 8.6025L8.364 4.6025ZM9.30366 5.92924L7.25 9.2151V14.25H10.6893L13.25 11.6893V7.50778L9.30366 5.92924Z',
    fill: '#4B5563'
  }));
};

exports.map_area = map_area;